import { Component } from '@angular/core';

@Component({
    selector: 'center-content',
    templateUrl: './center.component.html',
    styleUrls: ['./center.component.css']
})
export class CenterComponent {
}
